<template>
  <div class="vtitle">
    <div class="vacancy-name">
      <div v-if="!edited" class="row-block" @click="set_edited(true)">
        <span>{{ vacancy.name }}</span>

        <vbutton class="group" color="transparent" type="icon" icon="icon_edit" />
      </div>

      <template v-else>
        <div class="input-group">
          <input ref="input" v-model="name" type="text" @keyup.enter.stop="save" />

          <button class="accept" @click="save"></button>
        </div>
        <!-- <button class="cancel" @click="set_edited(false)">{{ $tr('common.cancel') }}</button> -->
        <vbutton
          class="cancel"
          label="common.cancel"
          color="transparent"
          text_color="grey"
          @click="set_edited(false)"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Vtitle',

  data() {
    return {
      edited: false,
      name: ''
    };
  },

  computed: {
    ...mapGetters('vacancy_new', { vacancy: 'item' })
  },

  created() {
    this.name = this.vacancy.name;

    this.$root.$on('vacancy_save', () => {
      this.save();
    });
  },

  destroyed() {
    this.$root.$off('vacancy_save');
  },

  methods: {
    set_edited(v) {
      this.edited = v;

      if (this.edited) {
        this.name = this.vacancy.name;

        setTimeout(() => {
          this.$refs.input.focus();
        }, 100);
      }
    },

    resetChangesTimestamps() {
      this.$store.commit('vacancy/resetChangesTimestamps');
    },

    save() {
      if (this.name.replace(/\s+/g, '').length === 0) {
        this.set_edited(false);

        return false;
      }

      if (this.name !== '') {
        this.$store.dispatch('vacancy_new/save', {
          id: this.vacancy.id,
          name: this.name
        });

        this.$store.commit('vacancy/update', {
          model: this.$store.getters['vacancy/one'],
          data: {
            name: this.name
          }
        });

        this.resetChangesTimestamps();
      }

      this.edited = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.vtitle {
  margin-bottom: 37px;
  padding-top: 3px;
  padding-bottom: 4px;
  border-bottom: 1px solid $grey-light;
  font-weight: 500;
  font-size: 22px;
  color: $main-dark;
}

.vacancy-name {
  box-sizing: border-box;
  display: flex;
  min-width: 500px;
  width: 100%;

  .row-block {
    width: 100%;
    padding-left: 10px;

    span {
      font-size: 26px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .group {
    display: flex;
    align-items: center;
    margin-left: 6px;

    &:hover {
      cursor: pointer;
    }

    .icon {
      height: 15px;
      margin-right: 5px;
    }

    span {
      color: $green;
      font-size: 16px;
      font-weight: 500;
    }
  }

  .input-group {
    display: flex;
    position: relative;
    width: 80%;
    max-width: 470px;
  }

  input {
    font-size: 26px;
    padding: 10px 45px 10px 10px;
    height: 40px;
    border: 1px solid #dddddd;
    border-radius: 2px 0 0 2px;
    color: #555;
    width: 100%;
    border-right-width: 0;
  }

  button {
    border: none;

    &:hover {
      cursor: pointer;
    }
  }

  .accept {
    height: 40px;
    width: 40px;
    min-width: 40px;
    background-color: $green;
    background-image: url('/static/images/elements/trigger_on.svg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 15px;
    border-radius: 0 2px 2px 0;
  }

  .cancel {
    margin-left: 10px;
    color: $green;
    font-weight: 500;
    font-size: 16px;
    background: transparent;
  }
}
</style>
